import { FC } from 'react'
import { useParams } from 'react-router-dom'

import CONFIG from '../../../../config'
import { FormResponseStatus } from '../../../models'
import { Layout } from '../../../containers'
import { Card, Modal, Title, useModal, FormMessageError, Loading, LinkBack } from '../../../components/UI'
import { AdminAdsForm, AdminAdsFormSuccess } from '../../../components'
import { useAds } from '../../../hooks'

const AdminAdsEditPage:FC = () => {
  const { id } = useParams<{ id: string }>()
  const modal = useModal()
  const ad = useAds('BYID', Number(id))

  const onFormSubmitChange = (status: FormResponseStatus, message: string = '') => {
    modal.setStatus(status)
    modal.setMessage(message)
    modal.open()
  }

  return (
    <Layout role="ADMIN_ROLE">
      <div className="container register-wrapper pt-50 pb-70">
        <div className="d-flex justify-content-between">
          <Title border>Actualizar Anuncio</Title>

          <LinkBack link={CONFIG.ROUTES.ADMIN.ADS.HOME} />
        </div>

        <Card showOnly="lg" className="lg:py-70 lg:px-70 mt-50 lg:mt-25">
          {ad.data ?
              <AdminAdsForm
                type="EDIT"
                ad={ad.data}
                onSubmitChange={(status, message) => onFormSubmitChange(status, message)}
              />
            :
              <Loading align="center" />
          }
        </Card>
      </div>

      <Modal show={modal.show} maxWidth="490px" onClose={() => modal.close()}>
        {modal.status === 'SUCCESS' &&
          <AdminAdsFormSuccess
            title="¡Actualización exitosa!"
            className="py-60 px-100"
            buttonText="ACTUALIZAR ANUNCIO"
            onClick={() => modal.close()}
          />
        }
        {modal.status === 'ERROR' &&
          <FormMessageError
            className="py-60 px-50"
            message="No ha sido posible completar la actualización"
            onClick={() => modal.close()}
          />
        }
      </Modal>
    </Layout>
  )
}

export { AdminAdsEditPage }